import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {}

  setItem(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getItem(key: string, defaultValue?: any) {
    const storedValue = localStorage.getItem(key);
    return storedValue ? storedValue : defaultValue;
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
